import React from "react";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { formatDistance } from "../../../utils/formatDistance";
import { capitalizeFirstLetterSafe } from "../../../utils/capitalizeFirstLetterSafe";

export function Row(props) {
  const { row, setPreviewRouteSelected } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.nameRoute ?? "---"}
        </TableCell>
        <TableCell align="center">{row?.description ?? "---"}</TableCell>
        <TableCell align="center">{formatDistance(row?.distance)}</TableCell>
        <TableCell align="center">
          {capitalizeFirstLetterSafe(row?.difficulty) ?? "---"}
        </TableCell>
        <TableCell align="center">{row?.terrainType ?? "---"}</TableCell>
        <TableCell align="center">{row?.membershipType ?? "---"}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  onClick={() => {
                    setPreviewRouteSelected(row);
                    const previewMap =
                      document.getElementById("previewMapProvider");
                    if (previewMap) {
                      previewMap.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }}
                  startIcon={<VisibilityIcon />}
                >
                  Ver ruta
                </Button>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
